import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalize',
  standalone: true
})

export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string, fieldName: string): any[] {
    let normalized = [];
    if (items && searchText) {
      searchText = searchText.toLowerCase();
      normalized = items.filter(item => {
        if (item && item[fieldName]) {
          return item[fieldName].toLowerCase().includes(searchText);
        }
      });
    } else {
      normalized = items;
    }
    return normalized;
   }
}
